import { render } from "./EntityDashboard.vue?vue&type=template&id=aef78508&scoped=true"
import script from "./EntityDashboard.vue?vue&type=script&lang=js"
export * from "./EntityDashboard.vue?vue&type=script&lang=js"

import "./EntityDashboard.vue?vue&type=style&index=0&id=aef78508&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef78508"]])

export default __exports__